import {
  PageFooterVolunteeringLinksHolder,
  PageFooterVolunteeringLinksItem,
  PageFooterVolunteeringLinksList,
  PageFooterVolunteeringLinksTitle,
} from './PageFooterVolunteeringLinks.styled';
import { pageFooterVolunteeringLinksData } from './pageFooterVolunteeringLinksData';

export function PageFooterVolunteeringLinks() {
  return (
    <PageFooterVolunteeringLinksHolder>
      <PageFooterVolunteeringLinksTitle>
        Local Volunteer Opportunities
      </PageFooterVolunteeringLinksTitle>

      <PageFooterVolunteeringLinksList>
        {pageFooterVolunteeringLinksData.map((data) => (
          <PageFooterVolunteeringLinksItem
            type="link"
            key={data.title}
            href={data.href}
            trackClicked={{
              name: 'Local Volunteer Opp',
              properties: { context: 'Footer' },
            }}
          >
            {data.title}
          </PageFooterVolunteeringLinksItem>
        ))}
      </PageFooterVolunteeringLinksList>
    </PageFooterVolunteeringLinksHolder>
  );
}
